import Template from "../Model/Template";

export class TemplateToDataTransformer {

  /**
   * @param {*} data
   * @returns {Template}
   */
  from(data) {
    let transformed = new Template();
      transformed
        .setTemplate(data.html)
        .setId(data.id)
        .setCss(data.css);

    return transformed;
  }

}
